import { togglePhotoTextZoneButtons, togglePhotoTextZoneResetButton } from '../../../utils/photo-text-zone-utils';

type ValidatePhotoTextZoneHasContentProps = {
  canvas: fabric.Canvas;
  photoTextZone: fabric.Group;
  textBox: fabric.Textbox;
  SAS_DYNAMIC_BUTTONS: boolean;
};

export const validatePhotoTextZoneHasContent = ({
  SAS_DYNAMIC_BUTTONS,
  canvas,
  photoTextZone,
  textBox,
}: ValidatePhotoTextZoneHasContentProps): void => {
  if (textBox.text === '') {
    photoTextZone.data.hasContent = false;
    togglePhotoTextZoneButtons(true, canvas, photoTextZone, SAS_DYNAMIC_BUTTONS);
    togglePhotoTextZoneResetButton(false, canvas, photoTextZone);
    canvas.renderAll();
  }
};
